<!-- Date selection -->
<div
  class="date-box-wrapper"
  [ngClass]="{ 'is-invalid': !value && required && dateCtrl.invalid }"
>
  <p-calendar
    [ngClass]="{
      'is-invalid': !value && required && dateCtrl.invalid,
    }"
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit(checkValue($event))"
    [name]="key ?? 'calendar'"
    #dateCtrl="ngModel"
    [placeholder]="placeholder || 'Select date' | translate"
    [id]="key"
    [dateFormat]="primeNgFormat"
    [showIcon]="true"
    icon="fas fa-calendar-alt"
    [showClear]="clearButton"
    [showButtonBar]="false"
    [disabled]="disabled"
    [required]="required"
    appendTo="body"
    selectionMode="single"
    [showOnFocus]="true"
    [inputStyleClass]="
      'form-control' +
      (!value && required && dateCtrl.invalid ? ' is-invalid' : '')
    "
    [styleClass]="class"
    [minDate]="safeMinDate"
    [maxDate]="safeMaxDate"
    [showTime]="displayTime"
    hourFormat="24"
  ></p-calendar>
</div>

<!-- Errors -->
<div *ngIf="!value && required && dateCtrl.invalid" class="invalid-feedback">
  {{ requiredError }}
</div>
